import { EntidadeBase } from 'hay-core-react';
class TemplateCampoModel extends EntidadeBase {
  constructor() {
    super('templatecampo');
  }
}

export default new TemplateCampoModel();
